import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivateFn } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class QueryParamsValidationService {
    router = inject(Router);

    constructor() { }

    canActivate(
        route: ActivatedRouteSnapshot): boolean {

        const queryParams = route.queryParams;

        if (Object.keys(queryParams).length === 0) {
            // Redirect to the desired route if no query parameters are present
            this.router.navigate([404]);
            return false;
        }

        return true; // Allow navigation if query parameters exist
    }
}

export const QueryParamGuard: CanActivateFn = (next: ActivatedRouteSnapshot): boolean => {
    return inject(QueryParamsValidationService).canActivate(next);
}
